

import { Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { PropertyService } from '../app/properties/property.service';
import { ProfileService } from './profile.services';

@Injectable()
export class CacheService {

  constructor(private propertyService: PropertyService, private profileService: ProfileService) { }

  public init(): Observable<any> {
    return this.profileService.init().pipe(
      catchError((error: any) => {
        console.error('Error al inicializar servicio de perfiles', error);
        return of({});
      })
    );
  }

  public renew(): Observable<any> {
    return forkJoin(
      this.profileService.renew().pipe(
        catchError((error: any) => {
          console.error('Error al inicializar servicio de perfiles', error);
          return of({});
        })
      ),
      this.propertyService.renew().pipe(
        catchError((error: any) => {
          console.error('Error al inicializar servicio de propiedades', error);
          return of({});
        }
        )
      )
    )
  }

  public clear(): void {
    this.profileService.clear()
    this.propertyService.clear();
  }


}